import {useEffect, useRef, useState} from 'react';
import {SActionBtn, SBack, SLowcodeList, STableActions} from 'shj-components'
import {getAuth, iiHOC} from '@/utils/auth';
import config from './config.json';
import KeepAlive from 'react-activation';
import {useLocation, useNavigate} from 'react-router-dom'
import {dataConverLogPage, ruleConfigGetList} from '@/services/integrationConfig'

function TransformLogDom() {
  const listRef = useRef<any>();
  const [billSetList, setBillSetList] = useState([]);
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    let params = listRef?.current?.getSearch?.()?.getFieldsValue?.() || {};
    for (const key in params) {
      if (!params[key] && params[key] !== false) delete params[key];
    }
    return new Promise(async (resolve, reject) => {
      try {
        dataConverLogPage(current, pageSize, params).then(data => {
          resolve(data)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const sourceSystemArr = [
    { name: 'FMS', code: 'FMS' },
    { name: 'CRM', code: 'CRM' },
    { name: '供应链', code: 'SUPPLY_CHAIN' },
    { name: '交付', code: 'DELIVERY' },
    { name: 'OMS', code: 'OMS' },
    { name: 'WMS', code: 'WMS' },
    { name: 'HR', code: 'HR' },
    { name: '金蝶', code: 'KINGDEE' },
  ];
  const getStatusOptions = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const ruleCodeArr = await ruleConfigGetList({status: true});
        resolve({
          ruleCodeArr: ruleCodeArr,
          statusArr: [
            {
              name: '成功',
              code: true,
            },
            {
              name: '失败',
              code: false,
            },
          ],
          sourceSystemArr,
        });
      } catch (e) {}
    });
  };
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {},
    customRender: {
      statusRender(text: any) {
        return <div>{text ? '成功' : '失败'}</div>;
      },
      sourceSystemRender(text: any) {
        return sourceSystemArr.find((e) => e.code === text)?.name || '';
      },
      actionTool(text: any, record: any) {
        // if (!record.status) {
        //   return iiHOC(
        //     <TableActions>
        //       <ActionBtn primary onClick={() => {}}>
        //         重发
        //       </ActionBtn>
        //     </TableActions>,
        //   );
        // }
      },
    },
  };

  return <>
  <SBack title={`转换日志`}></SBack>
  <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
  </>
}

const TransformLog = (props: any) => {
  const location = useLocation()
  return (
    <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
      <TransformLogDom {...props} />
    </KeepAlive>
  );
};
export default TransformLog;
